export default __webpack_public_path__ + "static/media/undraw_Access_account_re_8spm.233eef88.svg";